import axios from 'axios';

const basePath = '/api/resource_portal/resources';

const resourceApi = {
  fetchResource({ id }) {
    return axios({
      method: 'get',
      url: `${basePath}/${id}`,
    });
  },
  updateResource(params) {
    return axios({
      method: 'patch',
      url: `${basePath}/current`,
      params,
    });
  },
};

export default resourceApi;
